exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.privacy-modal[data-v-4b2754a3] {\n  background-color: rgb(248, 230, 208) !important;\n}\n", ""]);

// exports
